export const environment = {
  production: true,
  api_url: 'https://api.honestgorilla.com',
   //api_url: 'http://localhost:7076',
   aap_url: 'https://honestgorilla.com'
};
